import {Component, OnInit} from '@angular/core'
import {MainTabsService} from "../../service/main-tabs.service";
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {UserBalanceService} from "../../service/users/userBalance.service";
import {CurrencyService} from "../../modules/currency/currency.service";
import {NavigationService} from "../../service/navigation.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private userBalanceService: UserBalanceService,
              private currencyService: CurrencyService,
              private mainTabsService: MainTabsService,
              private navigationService: NavigationService,
              private authenticationService: AuthenticationService) { }

  ngOnInit() {
    document.querySelector('.main__inner').addEventListener('scroll', ()=> {
      this.setTopScroll();
    });
  }

  isUserLogged() {
    return this.authenticationService.isUserLogged()
  }

  getEntries() {
    return this.isUserLogged() ? this.userBalanceService.getEntries() : 1000;
  }

  getWinnings() {
    return this.isUserLogged() ? this.userBalanceService.getWinnings() : 1000;
  }

  formatCurrency(amount): string {
    return this.currencyService.formatCurrency(amount);
  }

  setTopScroll() {
    const arrow = document.querySelector('.footer__scroll-btn');
    const scrolledBlock = document.querySelector('.main__inner');
    if (scrolledBlock && arrow) {
      const scrollTop = scrolledBlock.scrollTop;
      const scrollHeight = scrolledBlock.scrollHeight;
      const clientHeight = scrolledBlock.clientHeight;
      if (((clientHeight * 1.1) + scrollTop)  >= scrollHeight) {
        arrow.classList.add('is-top');
        return;
      } else {
        arrow.classList.remove('is-top');
      }
    }
  }

  goToSettings(e) {
    if (!this.disableGoingToSettings() && (!e.target.classList.contains('footer__terms'))) {
      this.navigationService.goToSettingsPage();
      this.mainTabsService.resetActiveTab();
    }
  }

  goToTerms() {
    this.navigationService.goToTermsPage();
    this.mainTabsService.resetActiveTab();
  }

  disableGoingToSettings(): boolean {
    return !this.isUserLogged();
  }
}
